import {HttpClient, HttpContext} from '@angular/common/http'
import {inject, Injectable, signal} from '@angular/core'
import {Interest} from '@sparbanken-syd/rt-backend'
import {X_API_KEY} from '@sparbanken-syd/sparbanken-syd-bankid'
import {Observable, tap} from 'rxjs'
import {environment} from '../../environments/environment'
import {SECRET} from '../../environments/secret'

@Injectable({
  providedIn: 'root'
})
export class InterestService {

  public interestRate = signal(3)
  // You _can_ but should _not_ write to this.
  public listRate = signal(0)
  public disclaimerText = signal<string[]>([])

  private readonly httpClient = inject(HttpClient)

  /**
   * Get the latest valid interest and disclaimer from database
   */
  public getLatestInterest(): Observable<Interest> {
    const url = `${environment.rtUrl}/interests/latest/l753`
    const context = new HttpContext().set(X_API_KEY, SECRET)
    return this.httpClient.get<Interest>(url, {context}).pipe(
      tap(interest => {
        this.interestRate.set(Number(interest.averageRate) || 0)
        this.listRate.set(Number(interest.averageRate) || 0)
        this.disclaimerText.set(interest.disclaimerText || [])
      })
    )
  }
}
